import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const NAV = [
  { label: '首页', to: '/' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 顶部细条 */}
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 text-xs md:px-6">
          <p className="hidden items-center gap-2 sm:flex">
            <i className="ri-sound-module-fill text-accent-400" aria-hidden="true"></i>
            专注内部消息 · 前员工与知情人士一手职场爆料
          </p>
          <p className="flex items-center gap-2">
            <i className="ri-time-line text-accent-400" aria-hidden="true"></i>
            匿名投稿 · 人工核实 · 理性讨论
          </p>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`transition-colors duration-300 ${
          scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50'
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5" aria-label="51爆料 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-lg font-bold text-background-50">
              爆
            </span>
            <span className="flex items-baseline gap-1 font-display text-xl font-bold text-foreground-950 md:text-2xl">
              51
              <span className="text-primary-600">爆料</span>
            </span>
          </Link>

          {/* 桌面导航 */}
          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/about#contact"
              className="hidden items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-700 sm:inline-flex"
            >
              <i className="ri-megaphone-fill" aria-hidden="true"></i>
              匿名投稿
            </Link>
            <button
              type="button"
              aria-label={open ? '关闭菜单' : '打开菜单'}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 md:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'} aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden" aria-label="移动端导航">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about#contact"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-megaphone-fill" aria-hidden="true"></i>
              匿名投稿
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}